module.exports = __webpack_public_path__ + "static/media/bg.90b44238.svg";